<div class="rel psu-bfr psu-aft deco-out">
  <div class="full nlf-middle-center psu-bfr psu-aft deco-in">
    <div class="img-bx full">
      <figure class="full flicker rel hdn psu-bfr psu-aft"></figure>
    </div>
  </div>
</div>
